import { Action } from '@ngrx/store';
import { TTnAOrderTemplateActionType } from './tna-order-template.models';
import {
  TREQUEST_AUTO_UPDATE_TARGET_DATES,
  TREQUEST_UPDATE_STEP_BY_TEMPLATE_ID,
  TRESPONSE_GET_TNA_ORDER_TEMPLATE,
} from '@monorepo/types';
import { TLiftedFormModel } from '@monorepo/ui';

export class SetShowTnAOrderTemplatesLoader implements Action {
  readonly type = TTnAOrderTemplateActionType.SetShowTnAOrderTemplatesLoader;
  constructor(public showLoader: boolean) {}
}

export class ClearTnAOrderTemplates implements Action {
  readonly type = TTnAOrderTemplateActionType.ClearTnAOrderTemplates;
  constructor() {}
}

export class GetTnAOrderTemplates implements Action {
  readonly type = TTnAOrderTemplateActionType.GetTnAOrderTemplates;
  constructor(public tnaOrderTemplateId: string, public showLocalLoader?: boolean) {}
}

export class GetTnAOrderTemplatesSuccess implements Action {
  readonly type = TTnAOrderTemplateActionType.GetTnAOrderTemplatesSuccess;
  constructor(public tnaOrderTemplateRes: TRESPONSE_GET_TNA_ORDER_TEMPLATE) {}
}

export class GetTnAOrderTemplatesFailure implements Action {
  readonly type = TTnAOrderTemplateActionType.GetTnAOrderTemplatesFailure;
}

export class AutoUpdateTargetDates implements Action {
  readonly type = TTnAOrderTemplateActionType.AutoUpdateTargetDates;
  constructor(public payload: TREQUEST_AUTO_UPDATE_TARGET_DATES, public orderTnaId: string) {}
}

export class AutoUpdateTargetDatesSuccess implements Action {
  readonly type = TTnAOrderTemplateActionType.AutoUpdateTargetDatesSucces;
}

export class AutoUpdateTargetDatesFailure implements Action {
  readonly type = TTnAOrderTemplateActionType.AutoUpdateTargetDatesFailure;
}

export class AddUpdateTnAOrderTemplate implements Action {
  readonly type = TTnAOrderTemplateActionType.AddUpdateTnAOrderTemplate;
  constructor(public updateTnaOrderTemplateReq: TLiftedFormModel['payload']) {}
}

export class AddUpdateTnAOrderTemplateSuccess implements Action {
  readonly type = TTnAOrderTemplateActionType.AddUpdateTnAOrderTemplateSuccess;
}

export class AddUpdateTnAOrderTemplateFailure implements Action {
  readonly type = TTnAOrderTemplateActionType.AddUpdateTnAOrderTemplateFailure;
}

export class DeleteTnAOrderTemplate implements Action {
  readonly type = TTnAOrderTemplateActionType.DeleteTnAOrderTemplate;
  constructor(public deleteTnaOrderTemplateReq: TLiftedFormModel['payload']) {}
}

export class DeleteTnAOrderTemplateSuccess implements Action {
  readonly type = TTnAOrderTemplateActionType.DeleteTnAOrderTemplateSuccess;
}

export class DeleteTnAOrderTemplateFailure implements Action {
  readonly type = TTnAOrderTemplateActionType.DeleteTnAOrderTemplateFailure;
}

export class UpdateStepByTemplateId implements Action {
  readonly type = TTnAOrderTemplateActionType.UpdateStepByTemplateId;
  constructor(public payload: TREQUEST_UPDATE_STEP_BY_TEMPLATE_ID, public orderTnaId: string) {}
}
export class UpdateStepByTemplateIdSuccess implements Action {
  readonly type = TTnAOrderTemplateActionType.UpdateStepByTemplateIdSuccess;
}
export class UpdateStepByTemplateIdFailure implements Action {
  readonly type = TTnAOrderTemplateActionType.UpdateStepByTemplateIdFailure;
}

export class DownloadTnaOrderTemplate implements Action {
  readonly type = TTnAOrderTemplateActionType.DownloadTnaOrderTemplate;
  constructor(public templateId: string) {}
}

export class DownloadTnaOrderTemplateSuccess implements Action {
  readonly type = TTnAOrderTemplateActionType.DownloadTnaOrderTemplateSuccess;
}

export class DownloadTnaOrderTemplateFailure implements Action {
  readonly type = TTnAOrderTemplateActionType.DownloadTnaOrderTemplateFailure;
}

export type TTnAOrderTemplateActions =
  | SetShowTnAOrderTemplatesLoader
  | ClearTnAOrderTemplates
  | GetTnAOrderTemplates
  | GetTnAOrderTemplatesSuccess
  | GetTnAOrderTemplatesFailure
  | AutoUpdateTargetDates
  | AutoUpdateTargetDatesSuccess
  | AutoUpdateTargetDatesFailure
  | AddUpdateTnAOrderTemplate
  | AddUpdateTnAOrderTemplateSuccess
  | DeleteTnAOrderTemplate
  | DeleteTnAOrderTemplateSuccess
  | DeleteTnAOrderTemplateFailure
  | DownloadTnaOrderTemplate
  | DownloadTnaOrderTemplateSuccess
  | DownloadTnaOrderTemplateFailure
  | UpdateStepByTemplateId
  | UpdateStepByTemplateIdSuccess
  | UpdateStepByTemplateIdFailure;
